import {useState} from 'react'
import {
  MainContainer,
  CreditCardContainer,
  PaymentMethodContainer,
  Heading,
  CreditCardItem,
  CardNumber,
  NameLabel,
  CardHolderName,
  PaymentMethodCard,
  Input,
  PaymentHeaing,
} from './styledComponents'

const CreditCard = () => {
  const [cardNo, setCardNo] = useState('')
  const [cardHolderName, setCardHolderName] = useState('')
  const onChangeCardNo = event => {
    setCardNo(event.target.value)
  }
  const onChangeCardHolderName = event => {
    setCardHolderName(event.target.value)
  }
  return (
    <MainContainer>
      <CreditCardContainer>
        <Heading>CREDIT CARD</Heading>
        <CreditCardItem data-testid="creditCard">
          <CardNumber>{cardNo}</CardNumber>
          <NameLabel>CARDHOLDER NAME</NameLabel>
          <CardHolderName>{cardHolderName.toUpperCase()}</CardHolderName>
        </CreditCardItem>
      </CreditCardContainer>
      <PaymentMethodContainer>
        <PaymentMethodCard>
          <PaymentHeaing>Payment Method</PaymentHeaing>
          <Input
            type="text"
            onChange={onChangeCardNo}
            placeholder="Card Number"
          />
          <Input
            type="text"
            onChange={onChangeCardHolderName}
            placeholder="Cardholder Name"
          />
        </PaymentMethodCard>
      </PaymentMethodContainer>
    </MainContainer>
  )
}
export default CreditCard
